// @flow
import React from "react";
import {
  FormGroup,
  Label,
  Input,
  Col,
  Button,
  Row,
  Collapse
} from "reactstrap";
import { connect } from "react-redux";
import Octicon, { Info } from "@githubprimer/octicons-react";
import landscapePreview from "../../../../assets/img/landscape.png";
import portraitPreview from "../../../../assets/img/portrait.png";
import polaroidPreview from "../../../../assets/img/polaroid.png";
import extendedOverlayPreview from "../../../../assets/img/extendedoverlay.png";
import { updateField } from "../../../../redux/actions/configActions";
import PhotoRatioOptions from "./PhotoRatioOptions";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config
  };
};

class PhotoRatio extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      photoRatioPopoverOpen: false
    };

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.toggle = this.toggle.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  toggle() {
    const { photoRatioPopoverOpen } = this.state;
    this.setState({
      photoRatioPopoverOpen: !photoRatioPopoverOpen
    });
  }

  // #endregion
  render() {
    const { config } = this.props;
    const { photoRatioPopoverOpen } = this.state;
    return (
      <FormGroup row>
        <Label for="photoRatio" sm={2}>
          Photo orientation
        </Label>
        <Col sm={10}>
          <div className="d-flex justify-content-inline">
            <Input
              type="select"
              value={config.photoRatio}
              name="photoRatio"
              id="photoRatio"
              required={config.setting !== "4"}
              onChange={this.handleChange}
              className="mr-2 dropdown-black"
            >
              <option value="" selected={!config.photoRatio} disabled>
                -- Select photo ratio --
              </option>
              <PhotoRatioOptions />
            </Input>
            <Button
              size="sm"
              className="btn-black"
              outline
              type="button"
              color="dark"
              onClick={this.toggle}
            >
              <Octicon size="medium" icon={Info} />
            </Button>
          </div>
        </Col>
        <Collapse isOpen={photoRatioPopoverOpen}>
          <Row>
            <Col>
              <h6 className="text-dark font-italic text-center font-weight-bold">
                Portrait
              </h6>
              <img
                className="col-md-6 col-sm-3 mx-auto d-block"
                src={portraitPreview}
                alt="Portrait format preview"
              />
            </Col>
            <Col>
              <h6 className="text-dark font-italic text-center font-weight-bold">
                Landscape
              </h6>
              <img
                className="col-md-12 col-sm-3 mx-auto d-block"
                src={landscapePreview}
                alt="Landscape format preview"
              />
            </Col>
            <Col>
              <h6 className="text-dark font-italic text-center font-weight-bold">
                Polaroid{" "}
              </h6>
              <img
                className="col-md-6 col-sm-3 mx-auto d-block"
                src={polaroidPreview}
                alt="Polaroid format preview"
              />
            </Col>
            <Col>
              <h6 className="text-dark font-italic text-center font-weight-bold">
                Extended overlay
              </h6>
              <img
                className="col-md-6 col-sm-3 mx-auto d-block"
                src={extendedOverlayPreview}
                alt="Extended overlay format preview"
              />
            </Col>
          </Row>
        </Collapse>
      </FormGroup>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoRatio);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/PhotoRatio.jsx